import './setEnv' // a polyfill of sorts to set the ENV config
const { IS_QUAL, IS_DEV, IS_LOCAL, IS_TRAIN } = window.env

export const getDomainName = (): string => {
  if ( IS_LOCAL) {
    return 'http://localhost:3002'
  } else if ( IS_DEV ) {
    return 'https://dev.provider-portal.lakelandcareinc.com'
  } else if ( IS_QUAL ) {
    return 'https://qual.provider-portal.lakelandcareinc.com'
  } else if ( IS_TRAIN ) {
    return 'https://train.provider-portal.lakelandcareinc.com'
  } else {
    return 'https://provider-portal.lakelandcareinc.com'
  }
}

export const getBannerColor = (): string => {
  if ( IS_DEV ) {
    return 'headerNavbarDev'
  } else if ( IS_QUAL ) {
    return 'headerNavbarQual'
  } else if ( IS_TRAIN ) {
    return 'headerNavbarTrain'
  } else {
    return 'headerNavbar'
  }
}

export const getFolderName = (): string => {
  if ( IS_LOCAL) {
    return ''
  } else if ( IS_DEV ) {
    return 'dev'
  } else if ( IS_QUAL ) {
    return 'qual'
  } else if ( IS_TRAIN ) {
    return 'train'
  } else {
    return 'prod'
  }
}